<script>
//	import {AUTH_DATA} from '../auth/auth.js'
//	import {toDate,pass} from '../csql.js'
	import {acListCheck, getLoggedUser,toDate} from '../global.js'
	import {createEventDispatcher} from 'svelte'

	const dispatch = createEventDispatcher()
	export let item = {}	

	let permiso= "caja-ar" //$AUTH_DATA.permisos.split(",") //"caja-ba"  // caja-ur 
	let is_caja_ur = acListCheck('CAJA-UR') //permiso.indexOf('CAJA-UR')!==-1
	let is_caja_ba = acListCheck('CAJA-BA') //permiso.indexOf('CAJA-BA')!==-1

	let selected = 0

	let permiso_requerido = 'CAJA-'+item.concepto.substr(0,2)+(JSON.parse(item.registro)).moneda


	const is_sensible = (val) => ["nro_tarjeta","nrotarjeta", "nrotarjetasrc", "nrodocumento", "codigo", "nrocbu"].indexOf(val)!==-1

	const checkout = (cla,val) => {
		if( (!acListCheck(permiso_requerido) && is_sensible(cla)) || ((item.estado==='OK' || item.estado==='RECH') && is_sensible(cla))) {
			let secure_val = ''
			let long_t= val.length
			if(long_t>5){
				let pri2 = val.substr(0,2)
				let ult4 = val.substr(-4)
				secure_val = pri2 + '*'.repeat(long_t-6)+ ult4
			}else secure_val = '*'.repeat(long_t)
			return secure_val
 		}else{
			return val
		}

	}

	function guardar(estado){
		let pay = JSON.parse(JSON.stringify(item))
		delete pay.RowNum
		pay.estado = estado
		if(estado !== 'OK' && estado !=='RECH') pay.estados = 'OK,RECH'
		else pay.estados = ''
		let reg = JSON.parse(pay.registro)
		if(estado==='RECH' || estado==='CUOTA1-RE') reg['motivo_rech'] = prompt('Motivo del rechazo') || 'Sin descripcion'
		reg['timestamp'] = (new Date).toLocaleString()
		reg['usuario'] = getLoggedUser()
		pay.registro = JSON.stringify(reg)
		dispatch('save',{item:pay})
	}



</script>


<details class="mb-2 p-2 border-bottom">
	<summary class="bb">
		<small class="me-3">{toDate(item.lastupdate).fecha}</small>
		<em class="{item.estado.toLowerCase()} me-3" style="width: 12ch;">[{item.estado}]</em> {item.idcliente} # {item.tipo} - {item.concepto}
		<!--br><section><small>{toDate(item.lastupdate).fecha}</small></section-->
	</summary>
	<hr>
	<p>Cliente : {(JSON.parse(item.registro)).razonsocial||'   '}</p>
	{#each Object.keys(JSON.parse(item.registro)) as clave, index}
		{#if clave!=='razonsocial'}
			<pre class="m-0" style="color:{clave==='motivo_rech'?'red':''}">
				<span class="lbl">{clave}</span> : {checkout(clave,JSON.parse(item.registro)[clave])}
			</pre>
		{/if}
	{/each}

	{#if item.estados.length && acListCheck(permiso_requerido)}

		<hr><p class="mb-1" style="text-align: right;margin-right: 1rem;">
	  	{#each item.estados.split(',') as estado, index}
	  		<button class="btn btn-sm btn-dark me-1" on:click={()=>guardar(estado)} 
	  			disabled={item.estado==='OK' || item.estado==='RECH' }>{estado}
	  		</button>
	  	{/each}
  		</p>
	{/if}
</details>


<style>
	details[open]{
		background-color: lightgray;
		border-radius: .2rem;
	}
	em.rech{ color: red;}
	em.ok{  color: green; }
	em.pend{  color: orange; }
	em.cuota1-re { color:purple }
	em.cuota1-ok { color:lime }
</style>